// Inherited state controller — disables toggles when a flag is inherited from a higher scope
// Used by feature flag branch toggles: when global or group toggle is ON,
// branch toggles are disabled and an "Inherited" badge is shown.

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "badge"]
  static values = { inherited: Boolean }

  inheritedValueChanged() {
    this.toggleTargets.forEach((el) => {
      el.disabled = this.inheritedValue
      el.classList.toggle("opacity-50", this.inheritedValue)
    })
    this.badgeTargets.forEach((el) => {
      el.textContent = this.inheritedValue ? "Inherited" : ""
      el.classList.toggle("hidden", !this.inheritedValue)
    })
  }
}
